import { alphabet, length } from '../../constants/id-suffix';

function extractOriginalId(id) {
  const suffixRegexp = new RegExp(`-[${alphabet}]{${length}}$`);
  return id.replace(suffixRegexp, '');
}

export default extractOriginalId;
